import { useGetDialogsQuery } from "../../dialogs/dialogsSlice";
import { order } from "./statisticsConstants";

const useStatisticsWidget = () => {
  const dialogs = useGetDialogsQuery();

  const stats = dialogs?.data
    ?.filter((item) => item?.status.toLowerCase() !== "wait_for_system")
    ?.reduce(
      (acc, item) => {
        acc.total += 1;
        acc.statusCounts[item.status] =
          (acc?.statusCounts[item.status] || 0) + 1;
        return acc;
      },
      { total: 0, statusCounts: {} },
    );

  const statusEntries = !!stats?.statusCounts
    ? Object.entries(stats?.statusCounts).map(([status, count]) => ({
        status,
        count,
        percentage: ((count / stats.total) * 100).toFixed(2),
      }))
    : [];

  const reorderedEntries = statusEntries?.sort(
    (a, b) => order.indexOf(a.status) - order.indexOf(b.status),
  );

  return { chartData: reorderedEntries, dialogsData: dialogs?.data, isLoading: dialogs?.isLoading };
};

export default useStatisticsWidget;
